import React from "react"
import { Helmet } from "@helpers/Helmet"
import { Header } from "@components/header"
import { Container, container } from "@components/wrapper"
import clsx from "clsx"
import { BasicLink } from "@components/typography"
import { FaChevronRight } from "react-icons/fa"
import { CareerColumn, CareerSearch } from "@modules/career-list/components"
import { HariseninFooter } from "@components/harisenin"
import { Job, JobCategory } from "@interfaces/career"
import { JobsProvider } from "@modules/career-list/context/JobsContext"
import { createMarkup } from "@lib/functions"

export interface CareerListPageProps {
  initialData: Job[]
  categoryDetail: JobCategory | null
}

function CareerListPage({ initialData, categoryDetail }: CareerListPageProps) {
  return (
    <JobsProvider initialJobs={initialData}>
      <CareerList categoryDetail={categoryDetail} />
    </JobsProvider>
  )
}

function CareerList({ categoryDetail }: { categoryDetail: JobCategory | null }) {
  console.log(categoryDetail)
  return (
    <>
      <Helmet title={categoryDetail?.category_name ?? "Semua Lowongan"} isIndexed />
      <Header />

      <nav
        className={clsx(
          container,
          "flex sm:gap-4 items-center sm:mt-5",
          "mt-3 sm-only:text-xxs gap-2"
        )}
      >
        <BasicLink href="/" className="text-grey-97 font-semibold">
          Beranda
        </BasicLink>
        <FaChevronRight className="sm:text-xxs text-[6px]" />
        <div className="text-green font-semibold">
          {categoryDetail?.category_name ?? "Semua Lowongan"}
        </div>
      </nav>

      <main className="sm:pt-[42px] sm:pb-60px pt-14px pb-10">
        <Container className="sm:mb-[42px] mb-5">
          <h1 className="sm:text-[36px] text-xl font-medium mb-4">
            {categoryDetail?.category_name ?? "Ayo, Jadi Bagian dari harisenin.com!"}
          </h1>
          {categoryDetail?.category_description ? (
            <p dangerouslySetInnerHTML={createMarkup(categoryDetail?.category_description)} />
          ) : (
            <p className="">Temukan peran yang cocok untukmu dan bergabung bersama kami</p>
          )}
        </Container>

        <CareerSearch />
        {/* <CareerInfo /> */}
        <CareerColumn />
      </main>

      <HariseninFooter />
    </>
  )
}

export default CareerListPage
